// import { combineReducers } from 'redux';
import { combineReducers } from '@reduxjs/toolkit';
import AuthTypes from '../types/AuthType';
import { User } from './AuthReducer';
import { Dashboard } from './DashboardReducer';
import { Notifications } from './NotificationsReducer';
import { Global } from './GlobalReducer';
import { Transactions } from './TransactionReducer';
import { PaymentMethods } from './PaymentMethodsReducer';
import { Clients } from './ClientsReducer';
import { TransactionDetails } from './TransactionDetailsReducer';
import { ClientDetails } from './ClientDetailsReducer';
import { Settlements } from './SettlementsReducer';
import { GlobalToastReducer } from './GlobalToastReducer';
import { GlobalModal } from './GlobalModalReducer';
import { SettlementDetails } from './SettlementDetailsReducer';
import { Accounts } from './AccountsReducer'; // keep until RTK migration completed
import { Merchants } from './MerchantsReducer';
import { Notes } from './NotesReducer';
import { NoteDetails } from './NoteDetailsReducer';
import { Tickets } from './TicketsReducer';
import { Settings } from './SettingsReducer';
import { SignUpRequests } from './SignUpRequestsReducer';
import { Beneficiaries } from './BeneficiariesReducer';
import { Wizard } from './WizardReducer';
import { Batch } from './BatchCreationReducer';
import { InternalTransfers } from './InternalTransfersReducer';
import { Transfers } from './TransfersReducer';
import { TopUps } from './TopUpReducer';
import { RecurringPayments } from './RecurringPaymentsReducer';
import { ReferredMerchants } from './ReferredMerchantReducer';
import { Referral } from './ReferralReducer';
import { RollingReseve } from './RollingReserveReducer';
import { PaymentOrders } from './PaymentOrderReducer';
import { SubMerchants } from './SubMerchantReducer';
//import accountsReducer from '../../redux-toolkit/accountsSlice'; // new RTK slice
import featureFlagsReducer from '../../redux-toolkit/featureFlagsSlice'; // Feature Flags reducer

const appReducer = combineReducers({
  User,
  Dashboard,
  Global,
  Transactions,
  PaymentMethods,
  TransactionDetails,
  Clients,
  Settlements,
  SettlementDetails,
  ClientDetails,
  GlobalToastReducer,
  GlobalModal,
  Accounts, // Old redux, Keep until migration stable and completed
  //Accounts: accountsReducer, // From RTK
  Merchants,
  Notes,
  NoteDetails,
  Tickets,
  Settings,
  SignUpRequests,
  Notifications,
  Beneficiaries,
  Wizard,
  Batch,
  InternalTransfers,
  Transfers,
  TopUps,
  RecurringPayments,
  ReferredMerchants,
  Referral,
  RollingReseve,
  PaymentOrders,
  SubMerchants,
  featureFlags: featureFlagsReducer, // Feature Flags reducer
});

const rootRedurer = (state, action) => {
  const newState = action.type === AuthTypes.actions.logoutSuccess ? undefined : state;
  return appReducer(newState, action);
};

export default rootRedurer;
